import Component from '../abstracts/Component';

export default class LanguageComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-lang]:not([data-lang=""])',
      geoBlocking: '[data-geoblocking]',
      geoBlockingProceed: '.js-geoblocking-proceed',
      geoBlockingCancel: '.js-geoblocking-cancel'
    }
  }

  get CONF() {
    return {
      placeHolder: '{0}'
    }
  }

  constructor() {
    super();
  }

  buildForm(action, lang) {
    const form = document.createElement('form');
    const input = document.createElement('input');

    form.classList.add('d-none');
    form.setAttribute('method', 'post');
    form.setAttribute('action', action);

    input.setAttribute('type', 'text');
    input.setAttribute('name', 'lang');
    input.setAttribute('value', lang);

    form.appendChild(input);
    document.body.appendChild(form);

    return form;
  }

  showLayer(content) {
    this.$emit(this.$customEvents.MODAL_EVENTS.show, {
      unsafeContent: content
    });
  }

  bindClassicChangeCountry() {
    this.$on('click.language', ({event}) => {
      event.preventDefault();
      const href = event.currentTarget.getAttribute('href');
      const langParameter = event.currentTarget.getAttribute('data-lang');

      this.buildForm(href, langParameter).submit()

    }, 'body', this.SELECTORS.main);
  }

  replaceName(str, newString) {
    return new Promise((resolve, reject) => {
      try {
        resolve(str.replace(this.CONF.placeHolder, newString));
      } catch (e) {
        reject(e);
      }
    });
  }


  bindGeoblocking() {
    this.$on('click.geoblocking', ({event}) => {
      event.preventDefault();
      this.action = event.currentTarget.getAttribute('href');
      this.lang = event.currentTarget.dataset.geoblockingLang;
      const country = event.currentTarget.dataset.geoblockingCountry;
      const messageContent = document.querySelector('.js-geoblocking-layer').innerHTML;
      this.replaceName(messageContent, country).then(res => {
        this.showLayer(res);
        this.$one('click.closeGeoModal', () => {
          $('icon-close').trigger('click');
        }, 'body', this.SELECTORS.geoBlockingCancel);
      });
    }, 'body', this.SELECTORS.geoBlocking);

    this.$on('click.geoblocking', ({event}) => {
      event.preventDefault();
      const form = this.buildForm(this.action, this.lang);
      form.submit();
    }, 'body', this.SELECTORS.geoBlockingProceed);

    this.$on('click.geoblockingCancel', ({event}) => {
      event.preventDefault();
      $('.icon-close').trigger('click');
    }, 'body', this.SELECTORS.geoBlockingCancel);
  }

  render() {
    this.log('Rendering...');
    this.bindClassicChangeCountry();
    this.bindGeoblocking();
  }
}
